module.exports = __webpack_public_path__ + "static/media/mail.cd95a727.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/contacto/mail.svg
// module id = 181
// module chunks = 0